import React from 'react';

const AdminTableLoadingOverlay = ({ loading, children }) => {
  return (
    <div className="relative min-h-[200px]">
      {children}
      {loading && (
        <div
          className="absolute inset-0 flex items-center justify-center z-10 rounded-lg bg-background/70 backdrop-blur-[2px]"
          aria-live="polite"
          aria-busy="true"
        >
          <div className="loading-spinner h-8 w-8 border-[3px]" />
        </div>
      )}
    </div>
  );
};

export default AdminTableLoadingOverlay;
